import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { Alert, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import * as app_consts from "../../../utils/app_consts";
import { fail_retrieve_tenant_promotions_message_settings, loading_retrieve_tenant_promotions_message_settings, reset_retrieve_tenant_promotions_message_settings, success_retrieve_tenant_promotions_message_settings } from '../../../reducers/auth_tenant/retrieve_tenant_promotions_message_settings_Slice';
import { DELETE_MESSAGE_ERROR_MSG, DELETE_MESSAGE_SUCCESS_MSG, RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { TENANT_ADD_PROMOTION_MESSAGE_SETTINGS_API, TENANT_DELETE_PROMOTION_MESSAGE_SETTINGS_API, TENANT_RETRIEVE_PROMOTION_MESSAGE_SETTINGS_API } from '../../../api/api_data';
import { getSelectedOption, messageToast } from '../../../utils/Utils';
import { Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, RSelect } from '../../Component';
import TextInput from '../../../pages/components/inputs/TextInput';
import { fail_update_promotion_message_setting, loading_update_promotion_message_setting, reset_update_promotion_message_setting, success_update_promotion_message_setting } from '../../../reducers/auth_tenant/update_promotion_message_setting_Slice';
import YesNoModal from '../YesNoModal';
import { fail_tenant_delete_promotion_message_setting, loading_tenant_delete_promotion_message_setting, reset_tenant_delete_promotion_message_setting, success_tenant_delete_promotion_message_setting } from '../../../reducers/auth_tenant/tenant_delete_promotion_message_setting_Slice';

const initial_state = { promotion_id: '', name: "", ussd_prompt: "", sms_message: "" };

const ViewMessagesPromotionDetailsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data }) => {

 const [page_data, setPageData] = useState([]);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [editMode, setEditMode] = useState(false);
 const [form_data, setFormData] = useState(initial_state);
 const [update_loading, setUpdateLoading] = useState(false);
 const [update_error, setUpdateError] = useState("");
 const [sent_data, setSentData] = useState(data);
 const [delete_modal, setDeleteModal] = useState(false);
 const [selected_delete, setSelectedDelete] = useState("");
 const [delete_error, setDeleteError] = useState("");

 useEffect(() => {
  if (isOpen && data)
  {
   // Dispatch
   setEditMode(false);
   retrieve_data(data);
   setSentData(data);
   setUpdateError('');
   setError("");
  }
  setOpen(isOpen);
 }, [isOpen, data]);

 const retrieve_data = (id) => {
  setError('');
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_promotions_message_settings, success_retrieve_tenant_promotions_message_settings, fail_retrieve_tenant_promotions_message_settings, RETRIVE_SETTINGS_DETAILS_ERROR_MSG, RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_MESSAGE_SETTINGS_API}/${id}`));
 };

 // Listener
 const retrieve_tenant_promotions_message_settings_listener = useSelector((state) => state.retrieve_tenant_promotions_message_settings.retrieve_tenant_promotions_message_settings);

 useEffect(() => {
  if (retrieve_tenant_promotions_message_settings_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_promotions_message_settings_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_tenant_promotions_message_settings_listener.status === app_consts.FAIL)
    {
     setError(retrieve_tenant_promotions_message_settings_listener.message);
     messageToast(retrieve_tenant_promotions_message_settings_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_promotions_message_settings_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_tenant_promotions_message_settings_listener.data);
    }
    setLoading(false);
    dispatch(reset_retrieve_tenant_promotions_message_settings());
   }
  }
 }, [retrieve_tenant_promotions_message_settings_listener]);

 const handle_add_message = () => {
  setUpdateError('');
  // 
  dispatch(tenant_auth_actions_helper(loading_update_promotion_message_setting, success_update_promotion_message_setting, fail_update_promotion_message_setting, UPDATE_SETTINGS_DETAILS_ERROR_MSG, UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_ADD_PROMOTION_MESSAGE_SETTINGS_API}`, { ...form_data, promotion_id: sent_data }));
 };

 // Listener
 const update_promotion_message_setting_listener = useSelector((state) => state.update_promotion_message_setting.update_promotion_message_setting);

 useEffect(() => {
  if (update_promotion_message_setting_listener.status !== app_consts.IDLE)
  {
   if (update_promotion_message_setting_listener.status === app_consts.LOADING)
   {
    setUpdateLoading(true);
    setUpdateError("");
   } else
   {
    setUpdateLoading(false);
    if (update_promotion_message_setting_listener.status === app_consts.FAIL)
    {
     setUpdateError(update_promotion_message_setting_listener.message);
     messageToast(update_promotion_message_setting_listener.message, app_consts.FAIL);
    } else if (update_promotion_message_setting_listener.status === app_consts.SUCCESS)
    {
     messageToast(UPDATE_SETTINGS_DETAILS_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     retrieve_data(sent_data);
     setEditMode(false);
    }
    dispatch(reset_update_promotion_message_setting());
   }
  }
 }, [update_promotion_message_setting_listener]);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...form_data, [e.target.name]: e.target.value });
 };

 const handle_delete_message = () => {
  setDeleteError("");
  dispatch(tenant_auth_actions_helper(loading_tenant_delete_promotion_message_setting, success_tenant_delete_promotion_message_setting, fail_tenant_delete_promotion_message_setting, DELETE_MESSAGE_ERROR_MSG, DELETE_MESSAGE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_DELETE_PROMOTION_MESSAGE_SETTINGS_API}`, { promotion_id: sent_data, name: selected_delete?.name }));
 };

 // Listener
 const tenant_delete_promotion_message_setting_listener = useSelector((state) => state.tenant_delete_promotion_message_setting.tenant_delete_promotion_message_setting);

 useEffect(() => {
  if (tenant_delete_promotion_message_setting_listener.status !== app_consts.IDLE)
  {
   if (tenant_delete_promotion_message_setting_listener.status === app_consts.LOADING)
   {
    setDeleteError("");
   } else
   {
    if (tenant_delete_promotion_message_setting_listener.status === app_consts.FAIL)
    {
     setDeleteError(tenant_delete_promotion_message_setting_listener.message);
     messageToast(tenant_delete_promotion_message_setting_listener.message, app_consts.FAIL);
    } else if (tenant_delete_promotion_message_setting_listener.status === app_consts.SUCCESS)
    {
     messageToast(DELETE_MESSAGE_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     retrieve_data(sent_data);
     setEditMode(false);
     setDeleteModal(false);
     setSelectedDelete('');
    }
    dispatch(reset_tenant_delete_promotion_message_setting());
   }
  }
 }, [tenant_delete_promotion_message_setting_listener]);


 const open_delete_modal = (delete_item) => {
  setDeleteModal(true);
  setSelectedDelete(delete_item);
 };

 const close_delete_modal = () => {
  setDeleteModal(false);
  setSelectedDelete("");
 };

 return (
  <>
   <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"xl"}>
    <ModalHeader toggle={loading ? "" : closeModal}>Promotion Message Settings</ModalHeader>
    <ModalBody>
     {
      loading ?
       <>
        <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
         <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieving Promotion Message Settings...</div>
         <div className="nk-loader mt-2  w-70 m-auto "></div>
        </div>
       </>
       :
       <>
        {
         error ?
          <>
           <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
            <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
           </div>
          </>
          :
          <>
           <div className='mt-4'>
           </div>

           {
            editMode &&
            <>
             <Row className="g-4">
              <Col lg={6}>
               <div className="form-group">
                <div className="form-label-group">
                 <label className="form-label">
                  <label className="form-label mb text-md" htmlFor="retrunable">
                   Name<span className='text-danger pr-2'>{` *`}</span>
                  </label>
                 </label>
                </div>
                <div className="w-100">
                 <RSelect
                  options={page_data?.create_edit_settings_data}
                  className="w-100"
                  placeholder="Search"
                  value={getSelectedOption(form_data?.name, page_data?.create_edit_settings_data)}
                  onChange={(e) => { setFormData({ ...form_data, name: e?.value }); }}
                 />
                </div>
               </div>
              </Col>
              <TextInput
               label="USSD Prompt Message"
               helper="(160 Characters Max)"
               type="text"
               id_val="campaignussd_prompt_id"
               value={form_data?.ussd_prompt}
               colSize="6"
               required
               maxlength={160}
               name="ussd_prompt"
               handleChange={handleChange}
              />
              <TextInput
               label="SMS Message"
               helper="(160 Characters Max)"
               type="text"
               id_val="sms_message"
               value={form_data?.sms_message}
               colSize="6"
               required
               maxlength={160}
               name="sms_message"
               handleChange={handleChange}
              />
             </Row>
             <hr />
             <Row className="g-4 mt-4">
              {update_error && (
               <div className="mb-3 w-100">
                <Alert color="danger" className="alert-icon">
                 <Icon name="alert-circle" /> {update_error}{" "}
                </Alert>
               </div>
              )}
              <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
               <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                Cancel
               </Button>
               <Button onClick={handle_add_message} disabled={
                (update_loading) ||
                !(form_data?.name && form_data?.ussd_prompt && form_data?.sms_message)
               } color="primary">
                {update_loading ? <Spinner size="sm" color="light" /> : "Add Message"}
               </Button>
              </Col>
             </Row>
            </>
           }
           {
            page_data?.create_edit_settings_data && page_data?.message_settings?.length > 0 ?
             <>
              {
               !editMode && (
                <>
                 {
                  page_data?.create_edit_settings_data && page_data?.create_edit_settings_data?.length > 0 &&
                  <>
                   <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ initial_state }); }} color="primary" size="sm">
                     Add Message
                    </Button>
                   </div>
                  </>
                 }
                </>
               )
              }
              <Row>
               <div className="nk-tb-list is-separate is-medium mb-3">
                {/* Card Grid Layout */}
                <div className="card-grid" style={{
                 display: 'grid',
                 gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                 gap: '12px',
                 padding: '5px 0'
                }}>
                 {page_data?.message_settings?.map((item, index) => (
                  <div
                   className="card card-bordered"
                   key={index}
                   style={{
                    border: '1px solid #e5e9f2',
                    borderRadius: '6px',
                    background: '#fff',
                    transition: 'all 0.2s ease'
                   }}
                  >
                   <div className="card-inner" style={{
                    padding: '12px 14px'
                   }}>
                    <div className="card-content" style={{
                     display: 'flex',
                     flexDirection: 'column',
                     gap: '8px'
                    }}>
                     {/* Name Field */}
                     <div className="field-item" style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '2px 0',
                      borderBottom: '1px solid #f5f6fa'
                     }}>
                      <span className="sub-text" style={{
                       color: '#8094ae',
                       fontSize: '11px',
                       fontWeight: 500,
                       textTransform: 'uppercase',
                       letterSpacing: '0.3px',
                       minWidth: '85px'
                      }}>Name</span>
                      <span className="tb-lead" style={{
                       color: '#1c2f48',
                       fontSize: '13px',
                       fontWeight: 500,
                       textAlign: 'right',
                       wordBreak: 'break-word',
                       maxWidth: '65%',
                       marginLeft: '10px'
                      }}>{item?.name?.replace(/_/g, " ").toUpperCase() || "--"}</span>
                     </div>

                     {/* USSD Prompt Field */}
                     <div className="field-item" style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '2px 0',
                      borderBottom: '1px solid #f5f6fa'
                     }}>
                      <span className="sub-text" style={{
                       color: '#8094ae',
                       fontSize: '11px',
                       fontWeight: 500,
                       textTransform: 'uppercase',
                       letterSpacing: '0.3px',
                       minWidth: '85px'
                      }}>USSD Prompt</span>
                      <span className="tb-lead" style={{
                       color: '#1c2f48',
                       fontSize: '13px',
                       fontWeight: 500,
                       textAlign: 'right',
                       wordBreak: 'break-word',
                       maxWidth: '65%',
                       marginLeft: '10px'
                      }}>{item?.ussd_prompt || "--"}</span>
                     </div>

                     {/* SMS Message Field */}
                     <div className="field-item" style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '2px 0',
                      borderBottom: '1px solid #f5f6fa'
                     }}>
                      <span className="sub-text" style={{
                       color: '#8094ae',
                       fontSize: '11px',
                       fontWeight: 500,
                       textTransform: 'uppercase',
                       letterSpacing: '0.3px',
                       minWidth: '85px'
                      }}>SMS Message</span>
                      <span className="tb-lead" style={{
                       color: '#1c2f48',
                       fontSize: '13px',
                       fontWeight: 500,
                       textAlign: 'right',
                       wordBreak: 'break-word',
                       maxWidth: '65%',
                       marginLeft: '10px'
                      }}>{item?.sms_message || "--"}</span>
                     </div>

                     {/* Delete Action */}
                     <div className="field-item delete-item" style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      paddingTop: '6px',
                      borderTop: '1px solid #f5f6fa',
                      marginTop: '2px'
                     }}>
                      <Icon name="trash-fill" className="text-danger" style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => open_delete_modal(item)} />
                     </div>
                    </div>
                   </div>
                  </div>
                 ))}
                </div>
               </div>
              </Row>


              <YesNoModal openModal={delete_modal} setOpenModal={setDeleteModal} modalTitle={`Remove ${selected_delete?.name?.replace(/_/g, " ").toUpperCase()} ?`} errAmend={delete_error} setErrAmend={setDeleteError} buttonCancel="No" buttonConfirm="Yes" modalDescription={`Are you Sure that you want to Delete ${selected_delete?.name?.replace(/_/g, " ").toUpperCase()}?`} succFunc={handle_delete_message} />
             </>
             :
             <>
              <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
               <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>No Messages Found</div>
               {
                !editMode && (
                 <>
                  <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                   Add Message
                  </Button>
                 </>
                )
               }
              </div>
             </>
           }
          </>
        }
       </>
     }
    </ModalBody>
   </Modal>
  </>
 );
};

export default ViewMessagesPromotionDetailsModal;